export enum SavedReceiptsTab {
  RECEIPTS = 'RECEIPTS',
  PROOF_OF_NECESSITY = 'PROOF_OF_NECESSITY',
}
